var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"layout-wrapper"}},[_c('HorizontalNav',{attrs:{"type":_vm.topbar,"width":_vm.layoutWidth}}),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"header-title"},[_vm._v("Agenda de Clientes")]),_c('Calendar')],1)])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }